import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { IPermissionProps } from "../../../models/Login";
import { Table } from "./Table";

export const BenchRequirement = (permissions: IPermissionProps) => {
    const [reload, setReload] = useState(false);
    const toast = useRef<any>();

    const ShowCelebration = () => { };

    return (
        <>
            <Table toast={toast} permissions={permissions} reload={reload} setReload={setReload} ShowCelebration={ShowCelebration} />
            <Toast ref={toast} />
        </>
    );
}